import React from "react";
import { motion } from "framer-motion";
import { Calendar } from "lucide-react";
import { Button } from "../ui/button";
import { useBooking } from "../../context";

const FinalCTASection = () => {
  const { setShowBookingModal } = useBooking();

  return (
    <section className="section-spacing bg-gradient-to-b from-slate-950 to-slate-900" data-testid="final-cta-section">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Book Your Detail <span className="gradient-text">Today</span>
          </h2>
          
          <p className="text-lg text-slate-400 mb-6 max-w-2xl mx-auto">
            Clean car anywhere, everywhere.
          </p>

          <Button 
            onClick={() => setShowBookingModal(true)}
            className="btn-primary-glow text-slate-900 font-bold px-10 py-5 rounded-full text-lg"
            data-testid="final-cta-book-btn"
          >
            <Calendar className="w-5 h-5 mr-2" />
            Book Now
          </Button>

          <p className="text-slate-400 text-sm mt-6 max-w-xl mx-auto">
            Unsure of what to book or need an accurate price quotation with travel fee?{' '}
            <a href="tel:0478054648" className="text-cyan-400 hover:text-cyan-300 font-medium">Call</a> or{' '}
            <a href="sms:0478054648" className="text-cyan-400 hover:text-cyan-300 font-medium">text now</a> and we respond same day.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
